import { fetchAuthSession } from 'aws-amplify/auth'
import { API } from './API'

export const getJobInfos = async ({ jobId }: { jobId?: string }) => {
  if (jobId !== undefined) {
    const authSession = await fetchAuthSession()
    const { data } = await API(authSession).get(`/job/${jobId}`)
    return data?.job_infos
  }
  return undefined
}
